<script setup></script>

<template>
    <div class="flex h-12 md:h-14">
        <div class="border h-full border-colorBorderCareer" />
        <div class="w-1 h-5 md:h-6 rounded-r-md bg-primaryColor mt-1.5">
        </div>
    </div>
</template>
